import { reactive } from "vue";

export const wallets = reactive({});
const startTime = Date.now();

function handleEIP6963Announce(event) {
  const { info, provider } = event.detail;

  if (wallets[info.rdns]) {
    Object.assign(wallets[info.rdns], event.detail);
  } else {
    console.log(`Detected wallet: `, info);
    wallets[info.rdns] = {
      delay: Date.now() - startTime,
      ...event.detail
    };
  }
}

// Add event listener
addEventListener("eip6963:announceProvider", handleEIP6963Announce);
